var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6996 16.2273L12.2285 11.6455C13.3058 10.3636 13.8984 8.75455 13.8984 7.06364C13.8984 3.19091 10.8009 0 6.94921 0C3.12445 0 0 3.16364 0 7.06364C0 10.9364 3.12445 14.1 6.94921 14.1C8.24208 14.1 9.56189 13.7182 10.6662 13.0091L15.299 17.7C15.4876 17.8909 15.73 18 15.9993 18C16.2687 18 16.5111 17.8909 16.6996 17.7C16.8882 17.5091 16.9959 17.2364 16.9959 16.9636C17.0229 16.6909 16.9151 16.4455 16.6996 16.2273ZM11.9052 7.06364C11.9052 9.81818 9.69657 12.0545 6.97614 12.0545C4.25572 12.0545 2.04705 9.79091 2.04705 7.06364C2.04705 4.30909 4.25572 2.07273 6.97614 2.07273C9.69657 2.07273 11.9052 4.30909 11.9052 7.06364Z",
    fill: "#96A1AC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.b67b124af3d5db6a11f1241840a67ff5.svg";
export { ForwardRef as ReactComponent };